$(document).on("click", ".feedback-stars-average", function () {
  $("html,body").animate({
    scrollTop:
      $("#heading_e0d96e54-b8cd-46d7-9de6-c3c1a2b001ba").offset().top -
      ($("#logo-bar").height() + $(".top-bar").height()),
  });
  $("#collapse_e0d96e54-b8cd-46d7-9de6-c3c1a2b001ba").removeClass("collapse").addClass("collapse show");
});
